import { render, staticRenderFns } from "./SaveAdAnimatedIcon.vue?vue&type=template&id=28659cb0"
import script from "./SaveAdAnimatedIcon.vue?vue&type=script&lang=js"
export * from "./SaveAdAnimatedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports